<a class="btn btn-link small p-0 m-0" (click)="goOnOrganizationUnitDetail()">
    <em class="fas fa-link text-primary mr-1 fa-xs"></em>
    <span class="small">{{ organizationUnit.displayName }}</span>
</a>
